"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModalStack = void 0;
var stack = [];

var OpenModalStack = /*#__PURE__*/function () {
  function OpenModalStack() {
    _classCallCheck(this, OpenModalStack);
  }

  _createClass(OpenModalStack, [{
    key: "pushModalKey",
    value: function pushModalKey(modalKey) {
      var openModals = this.getOpenModals();

      if (openModals.includes(modalKey)) {
        return;
      }

      stack.push(modalKey);
    }
  }, {
    key: "popModalKey",
    value: function popModalKey() {
      var openModals = this.getOpenModals();

      if (!openModals.length) {
        return '';
      }

      var _stack$splice = stack.splice(openModals.length - 1, 1),
          _stack$splice2 = _slicedToArray(_stack$splice, 1),
          poppedModalKey = _stack$splice2[0];

      return poppedModalKey;
    }
  }, {
    key: "getOpenModals",
    value: function getOpenModals() {
      return stack;
    }
  }, {
    key: "clearOpenModals",
    value: function clearOpenModals() {
      stack.splice(0, stack.length);
    }
  }]);

  return OpenModalStack;
}();

exports.openModalStack = new OpenModalStack();